const replaceLink = () => {
  const link = document.querySelector(".js-replace-link");
  const linkTarget = document.querySelector(".js-replace-link-target");

  if (!link || !linkTarget) return;

  linkTarget.setAttribute("href", link.getAttribute("data-terms"));
};

export default replaceLink;
